<template>
  <div class="box">
    <tablePackaging
      :tableListData="postList"
      :tableOption.sync="tableOption"
      :isOperate="isOperate"
      :page="page"
      :searchFormList="searchFormList"
      @update="getTableChangePageData"
      @searchDate="getTableData"
    >
      <template v-slot:header>
        <div class="btn-wrap">
          <div class="left-wrap"></div>
          <div class="right-wrap">
            <el-button type="primary" @click="handelClickAdd" size="small"
              >添加</el-button
            >
          </div>
        </div>
      </template>
      <template slot-scope="scope" slot="operate">
        <el-tooltip
          class="item"
          popper-class="popper-class"
          content="权限分配"
          placement="bottom-end"
        >
          <!-- v-if="scope.row.username != 'admin'" -->
          <el-button
            icon="el-icon-setting"
            circle
            size="20"
            type="success"
            @click="downTransposition(scope.row)"
          ></el-button>
        </el-tooltip>
        <el-tooltip
          class="item"
          popper-class="popper-class"
          content="编辑"
          placement="bottom-end"
        >
          <!-- v-if="scope.row.username != 'admin'" -->
          <el-button
            icon="el-icon-edit-outline"
            circle
            size="20"
            type="success"
            @click="handelClickEdit(scope.row)"
          ></el-button>
        </el-tooltip>
        <el-tooltip
          class="item"
          popper-class="popper-class"
          content="删除"
          placement="bottom-end"
        >
          <el-button
            icon="el-icon-delete"
            circle
            type="success"
            @click="handleDelete(scope.row)"
          ></el-button>
        </el-tooltip>
      </template>
    </tablePackaging>
    <upDataFormPackaging
      ref="upDataFormPackaging"
      :editFormDefaulteArr="editFormDefaulteArr"
      @editUpData="editItemMsg"
      :title="title"
    ></upDataFormPackaging>

    <el-dialog title="账号管理" :visible.sync="dialogVisible" width="50%">
      <el-form
        :model="flashPromotion"
        ref="flashPromotionForm"
        :rules="rules"
        :inline="true"
        label-width="150px"
        size="small"
      >
        <el-form-item label="用户姓名：" prop="name">
          <el-input
            v-model="flashPromotion.name"
            style="width: 250px"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input
            v-model="flashPromotion.phone"
            v-bind:disabled="isEdit"
            style="width: 250px"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态：" prop="status">
          <el-select
            v-model="flashPromotion.status"
            clearable
            style="width: 250px"
          >
            <el-option
              v-for="item in statusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否是管理员" prop="adminRole">
          <el-select
            v-model="flashPromotion.adminRole"
            clearable
            style="width: 250px"
          >
            <el-option
              v-for="item in roleList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="handleDialogConfirm()" size="small"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog :visible.sync="DialogShow">
      <div slot="title" class="dialog-title">
        <span class="title-line"></span>
        <span class="title-text">权限分配</span>
      </div>
      <!--@check-change="changeEvent"-->
      <el-tree
        ref="funcTree"
        :data="funcTreeList"
        show-checkbox
        node-key="routeBid"
        :check-strictly="false"
        :default-checked-keys="checkList"
        style="margin: 20px 0 20px 100px"
        :accordion="true"
      >
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span class="func-name">{{ data.routeName }}</span>
        </span>
      </el-tree>
      <div class="from-btn-wrap">
        <el-button type="primary" @click="handelClickSubmit" size="small"
          >确定</el-button
        >
        <el-button type="primary" plain size="small" @click="handelClickCancel"
          >取消</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { query, create, update, deleteBm, detail } from '@/api/managementUser';
import { getRouteConfig, updateManagementUserRoutes } from '@/api/routes';
import { getAll } from '@/api/businessManager';
import tablePackaging from '@/components/tablePackaging';
import upDataFormPackaging from '@/components/upDataFormPackaging';
import { clone } from '@/utils/utils';

const defaultFlashPromotion = {
  muBid: null,
  name: null,
  phone: null,
  status: null,
  adminRole: null,
};

const defaultSearchObj = {
  page: {
    pageNum: 1,
    pageSize: 10,
  },
  searchInfo: {
    equipmentName: '',
    equipmentStationName: '',
  },
};

const submitFormDataDefault = {
  muBid: '',
  routesItemBids: [],
};

const defaultEditFormDefaulteArr = [
  {
    fieldName: 'name', //字段
    type: 'input', //类型
    name: '用户名', //名字
    size: 'long-inp', //尺寸
    maxLength: '200', //最大长度
    required: true, //是否必填
    value: '', //默认值
  },
  {
    fieldName: 'phone', //字段
    type: 'input', //类型
    name: '手机号', //名字
    size: 'long-inp', //尺寸
    maxLength: '200', //最大长度
    required: true, //是否必填
    value: '', //默认值
  },
  {
    fieldName: '状态', //字段
    type: 'status', //类型
    name: '用户名', //名字
    size: 'long-inp', //尺寸
    maxLength: '200', //最大长度
    required: true, //是否必填
    value: '', //默认值
  },
];
export default {
  data() {
    return {
      title: '新建大洲',
      muBid: '',
      postList: [],
      isOperate: true,
      dialogVisible: false,
      isEdit: false,
      editFormDefaulteArr: clone(defaultEditFormDefaulteArr),
      flashPromotion: Object.assign({}, defaultFlashPromotion),
      searchFormList: [],
      flavorList: [],
      funcTreeList: [],
      checkList: [],
      bmList: [],
      submitFormData: Object.assign({}, submitFormDataDefault),
      DialogShow: false,
      rules: {
        name: [{ required: true, message: '请输入用户名称', trigger: 'blur' }],
        phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        status: [{ required: true, message: '请选择有效性', trigger: 'blur' }],
        adminRole: [
          { required: true, message: '请选择是否是管理员', trigger: 'blur' },
        ],
      },
      statusList: [
        {
          label: '无效',
          value: 1,
        },
        {
          label: '有效',
          value: 0,
        },
      ],
      roleList: [
        {
          label: '否',
          value: false,
        },
        {
          label: '是',
          value: true,
        },
      ],
      tableOption: [
        //是否展示多选
        // {
        //   type: 'selection',
        //   label: '#',
        // },
        {
          prop: 'name',
          label: '用户名',
          overHidden: true,
          //sortable: 'orgName',
        },
        {
          prop: 'phone',
          label: '手机号',
          overHidden: true,
          //sortable: 'name',
        },
        {
          prop: 'statusDesc',
          label: '账号状态',
          overHidden: true,
          //sortable: 'name',
        },
        {
          prop: 'adminDesc',
          label: '是否是管理员',
          overHidden: true,
          //sortable: 'name',
        },
      ],
      searchObj: clone(defaultSearchObj),

      page: {
        pageNum: 1, //起始位置
        pageSize: 10, //每页条数
        totalCount: null, //总条数
      },
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    handleDialogConfirm() {
      this.$refs['flashPromotionForm'].validate((valid) => {
        if (valid) {
          this.$confirm('是否要保存?', '提示', {
            confirmButtonText: '是',
            cancelButtonText: '否',
            type: 'warning',
          }).then(() => {
            if (this.isEdit) {
              update(this.flashPromotion).then((response) => {
                this.$message({
                  message: '修改成功！',
                  type: 'success',
                });
                this.dialogVisible = false;
                this.getTableData();
              });
            } else {
              create(this.flashPromotion).then((response) => {
                this.$message({
                  message: '添加成功！',
                  type: 'success',
                });
                this.dialogVisible = false;
                this.getTableData();
              });
            }
          });
        } else {
          this.$message({
            message: '请填写必填项',
            type: 'error',
            duration: 1000,
          });
          return false;
        }
      });
    },
    handelClickSubmit() {
      let keys = this.$refs.funcTree.getCheckedKeys();
      if (keys.length == 0) {
        this.$message({
          type: 'warn',
          message: '请先选择权限',
        });
        return;
      }
      this.submitFormData.routesItemBids = keys;
      updateManagementUserRoutes(this.submitFormData).then((resp) => {
        if (resp.code == '200') {
          this.$message({
            type: 'success',
            message: '分配权限成功!',
          });
        } else {
          this.$message({
            type: 'success',
            message: resp.msg,
          });
        }
        this.submitFormData = Object.assign({}, this.submitFormDataDefault);
        this.DialogShow = false;
      });
    },
    handelClickCancel() {
      this.submitFormData = Object.assign({}, this.submitFormDataDefault);
      this.DialogShow = false;
    },
    getTableData() {
      query(this.searchObj.page).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.postList = res.data.records;
          this.page.pageNum = res.data.pageNum;
          this.page.pageSize = res.data.pageSize;
          this.page.totalCount = res.data.total;
        }
      });
    },
    getTableChangePageData(obj) {
      this.searchObj.page.pageNum = obj.pageNum;
      this.searchObj.page.pageSize = obj.pageSize;
      this.getTableData();
    },
    //添加
    handelClickAdd() {
      this.isEdit = false;
      this.dialogVisible = true;
      this.flashPromotion = Object.assign({}, defaultFlashPromotion);
    },
    //修改
    handelClickEdit(row) {
      this.dialogVisible = true;
      this.isEdit = true;
      detail(row.muBid).then((resp) => {
        this.flashPromotion = resp.data;
      });
      this.flashPromotion.muBid = row.muBid;
    },
    //删除
    handleDelete(row) {
      this.$myConfirm
        .showMsgBox({
          title: '提示',
          // confirmBtnText: '一并删除',
          // cancelBtnText: '仅删除账号',
          tips: '',
          content: '确定删除该账号？',
        })
        .then(() => {
          deleteBm(row.muBid).then((res) => {
            if (res.code == '200') {
              this.$msg.success('删除成功！');
              this.getTableData();
            }
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    editItemMsg(data) {
      if (!this.continentBid) {
        //新建
        continentCreate(data)
          .then((res) => {
            console.log(res);
            if (res.code == '200') {
              this.$refs.upDataFormPackaging.closeDialog();
              this.$msg.success('新建成功！');
              this.getTableData();
            }
            this.$refs.upDataFormPackaging.upDataMsg = '保存';
          })
          .catch(() => {
            this.$refs.upDataFormPackaging.upDataMsg = '保存';
            this.$msg.error(res.msg);
          });
      } else {
        //编辑
        data.continentBid = this.continentBid;
        continentUpdate(data)
          .then((res) => {
            if (res.code == '200') {
              this.$refs.upDataFormPackaging.closeDialog();
              this.$msg.success('修改成功！');
              this.getTableData();
            }
            this.$refs.upDataFormPackaging.upDataMsg = '保存';
          })
          .catch(() => {
            this.$refs.upDataFormPackaging.upDataMsg = '保存';
            this.$msg.error(res.msg);
          });
      }
    },
    upTransposition(row) {
      console.log(row);

      continentMoveUp(row.continentBid).then((res) => {
        if (res.code == 200) {
          this.$msg.success('操作成功！');
          this.getTableData();
        }
      });
      // if(row.rank -1  == 0){
      //   this.$msg('已经到顶了，无法上移！')
      // }
    },
    downTransposition(row) {
      this.submitFormData.muBid = row.muBid;
      this.checkList = [];
      getRouteConfig(row.muBid).then((resp) => {
        this.funcTreeList = resp.data;
        if (this.funcTreeList.length > 0) {
          for (let i = 0; i < this.funcTreeList.length; i++) {
            let item = this.funcTreeList[i];
            if (item.children.length > 0) {
              for (let m = 0; m < item.children.length; m++) {
                if (item.children[m].selected) {
                  // console.log(item.children[m])
                  this.checkList.push(item.children[m].routeBid);
                }
              }
            }
          }
        }
      });
      console.log(this.checkList);
      this.DialogShow = true;
    },
  },
  components: {
    tablePackaging,
    upDataFormPackaging,
  },
};
</script>

<style>
</style>